// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sp_container {
    display: flex;
    flex-direction: column;
    background-color: var(--bg-card);
    padding: 20px;
    border-radius: var(--radius-md);
    gap: 16px;
    border: 1px solid var(--border);
    box-shadow: var(--shadow-sm);
}

.sp_main_title {
    margin: 0;
    font-size: 20px;
    font-weight: 700;
    color: var(--text-primary);
}

.sp_section {
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 16px;
    background-color: var(--bg);
    border-radius: var(--radius-sm);
    border: 1px solid var(--border);
}

.sp_section_title {
    margin: 0;
    font-size: 15px;
    font-weight: 600;
    color: var(--text-primary);
}

.sp_fields_grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 12px;
}

.sp_field {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.sp_field_full {
    display: flex;
    flex-direction: column;
    gap: 4px;
    grid-column: 1 / -1;
}

.sp_field_toggle {
    justify-content: flex-start;
}

.sp_label {
    font-size: 12px;
    color: var(--text-muted);
    font-weight: 500;
}

.sp_input {
    width: 100%;
    padding: 6px 10px;
    border: 1px solid var(--border);
    border-radius: var(--radius-sm);
    font-size: 14px;
    font-weight: 600;
    background-color: var(--bg-card);
    color: var(--text-primary);
    box-sizing: border-box;
}

.sp_input_wide {
    width: 100%;
}

.sp_cover_picture_row {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
}

.sp_cover_picture_preview {
    width: 240px;
    object-fit: cover;
    border-radius: var(--radius-sm);
    border: 1px solid var(--border);
}

.sp_cover_picture_button {
    padding: 6px 14px;
    border-radius: var(--radius-sm);
    border: 1px dashed var(--border);
    background-color: var(--bg);
    color: var(--text-secondary);
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    transition: all var(--transition-fast);
}

.sp_cover_picture_button:hover {
    border-color: var(--primary);
    color: var(--primary);
    background-color: var(--bg-card);
}

.sp_cover_picture_filename {
    font-size: 12px;
    color: var(--text-muted);
    font-style: italic;
}

.sp_textarea {
    width: 100%;
    padding: 8px 10px;
    border: 1px solid var(--border);
    border-radius: var(--radius-sm);
    font-size: 13px;
    background-color: var(--bg-card);
    color: var(--text-primary);
    resize: vertical;
    box-sizing: border-box;
    font-family: inherit;
}

.sp_toggle {
    padding: 5px 14px;
    border-radius: var(--radius-sm);
    border: none;
    cursor: pointer;
    font-size: 13px;
    font-weight: 600;
    transition: all var(--transition-fast);
    width: -moz-fit-content;
    width: fit-content;
}

.sp_toggle_on {
    background-color: var(--primary);
    color: #fff;
}

.sp_toggle_off {
    background-color: var(--bg-card);
    color: var(--text-secondary);
    border: 1px solid var(--border);
}

.sp_submit_row {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    align-items: center;
}

.sp_submit_button {
    background-color: var(--primary);
    padding: 8px 20px;
    border-radius: var(--radius-sm);
    border: none;
    cursor: pointer;
    font-size: 13px;
    font-weight: 600;
    color: #fff;
    transition: all var(--transition-fast);
}

.sp_submit_button:hover:not(:disabled) {
    background-color: var(--primary-hover);
}

.sp_submit_button:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/pages/users/userById/UserSections/UserSignalProvider/userSignalProvider.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,gCAAgC;IAChC,aAAa;IACb,+BAA+B;IAC/B,SAAS;IACT,+BAA+B;IAC/B,4BAA4B;AAChC;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,aAAa;IACb,2BAA2B;IAC3B,+BAA+B;IAC/B,+BAA+B;AACnC;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,+BAA+B;IAC/B,+BAA+B;IAC/B,eAAe;IACf,gBAAgB;IAChB,gCAAgC;IAChC,0BAA0B;IAC1B,sBAAsB;AAC1B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,+BAA+B;IAC/B,+BAA+B;AACnC;;AAEA;IACI,iBAAiB;IACjB,+BAA+B;IAC/B,gCAAgC;IAChC,2BAA2B;IAC3B,4BAA4B;IAC5B,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,4BAA4B;IAC5B,qBAAqB;IACrB,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,wBAAwB;IACxB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,+BAA+B;IAC/B,+BAA+B;IAC/B,eAAe;IACf,gCAAgC;IAChC,0BAA0B;IAC1B,gBAAgB;IAChB,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;IACjB,+BAA+B;IAC/B,YAAY;IACZ,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,sCAAsC;IACtC,uBAAkB;IAAlB,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC,WAAW;AACf;;AAEA;IACI,gCAAgC;IAChC,4BAA4B;IAC5B,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,gCAAgC;IAChC,iBAAiB;IACjB,+BAA+B;IAC/B,YAAY;IACZ,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,sCAAsC;AAC1C;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB","sourcesContent":[".sp_container {\n    display: flex;\n    flex-direction: column;\n    background-color: var(--bg-card);\n    padding: 20px;\n    border-radius: var(--radius-md);\n    gap: 16px;\n    border: 1px solid var(--border);\n    box-shadow: var(--shadow-sm);\n}\n\n.sp_main_title {\n    margin: 0;\n    font-size: 20px;\n    font-weight: 700;\n    color: var(--text-primary);\n}\n\n.sp_section {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    padding: 16px;\n    background-color: var(--bg);\n    border-radius: var(--radius-sm);\n    border: 1px solid var(--border);\n}\n\n.sp_section_title {\n    margin: 0;\n    font-size: 15px;\n    font-weight: 600;\n    color: var(--text-primary);\n}\n\n.sp_fields_grid {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 12px;\n}\n\n.sp_field {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n}\n\n.sp_field_full {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    grid-column: 1 / -1;\n}\n\n.sp_field_toggle {\n    justify-content: flex-start;\n}\n\n.sp_label {\n    font-size: 12px;\n    color: var(--text-muted);\n    font-weight: 500;\n}\n\n.sp_input {\n    width: 100%;\n    padding: 6px 10px;\n    border: 1px solid var(--border);\n    border-radius: var(--radius-sm);\n    font-size: 14px;\n    font-weight: 600;\n    background-color: var(--bg-card);\n    color: var(--text-primary);\n    box-sizing: border-box;\n}\n\n.sp_input_wide {\n    width: 100%;\n}\n\n.sp_cover_picture_row {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    flex-wrap: wrap;\n}\n\n.sp_cover_picture_preview {\n    width: 240px;\n    object-fit: cover;\n    border-radius: var(--radius-sm);\n    border: 1px solid var(--border);\n}\n\n.sp_cover_picture_button {\n    padding: 6px 14px;\n    border-radius: var(--radius-sm);\n    border: 1px dashed var(--border);\n    background-color: var(--bg);\n    color: var(--text-secondary);\n    font-size: 13px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all var(--transition-fast);\n}\n\n.sp_cover_picture_button:hover {\n    border-color: var(--primary);\n    color: var(--primary);\n    background-color: var(--bg-card);\n}\n\n.sp_cover_picture_filename {\n    font-size: 12px;\n    color: var(--text-muted);\n    font-style: italic;\n}\n\n.sp_textarea {\n    width: 100%;\n    padding: 8px 10px;\n    border: 1px solid var(--border);\n    border-radius: var(--radius-sm);\n    font-size: 13px;\n    background-color: var(--bg-card);\n    color: var(--text-primary);\n    resize: vertical;\n    box-sizing: border-box;\n    font-family: inherit;\n}\n\n.sp_toggle {\n    padding: 5px 14px;\n    border-radius: var(--radius-sm);\n    border: none;\n    cursor: pointer;\n    font-size: 13px;\n    font-weight: 600;\n    transition: all var(--transition-fast);\n    width: fit-content;\n}\n\n.sp_toggle_on {\n    background-color: var(--primary);\n    color: #fff;\n}\n\n.sp_toggle_off {\n    background-color: var(--bg-card);\n    color: var(--text-secondary);\n    border: 1px solid var(--border);\n}\n\n.sp_submit_row {\n    display: flex;\n    justify-content: flex-end;\n    gap: 10px;\n    align-items: center;\n}\n\n.sp_submit_button {\n    background-color: var(--primary);\n    padding: 8px 20px;\n    border-radius: var(--radius-sm);\n    border: none;\n    cursor: pointer;\n    font-size: 13px;\n    font-weight: 600;\n    color: #fff;\n    transition: all var(--transition-fast);\n}\n\n.sp_submit_button:hover:not(:disabled) {\n    background-color: var(--primary-hover);\n}\n\n.sp_submit_button:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
